<template>
  <v-combobox
    v-model="selected"
    :items="items"
    chips
    v-bind="$attrs"
    multiple
    item-text="name"
    :item-disabled="item => item.disabled"
  >
    <template v-slot:selection="{ item }">
      <v-chip
        :color="item.disabled ? '' : '#2780E3'"
        :text-color="item.disabled ? '' : '#fff'"
        :close="!item.disabled"
        :disabled="item.disabled"
      >
        {{ item.name }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'AppChips',
  setup() {
    return {
      selected: [
        {
          disabled: true,
          name: 'Group1'
        }
      ],
      items: [
        {
          disabled: true,
          name: 'Group1'
        },
        {
          disabled: false,
          name: 'Group2'
        }
      ]
    };
  }
};
</script>
